import { ROUTE_NAME } from "@/constants/routes-name";
import { lazyWithRetry } from "@/utils/lazy-with-retry";

const ApiKeysPage = lazyWithRetry(() => import("../pages/keys"));

export const KEYS_ROUTE = {
  id: ROUTE_NAME.KEYS,
  path: ROUTE_NAME.KEYS,
  Component: ApiKeysPage,
};
